import { eventRoom, locationId, locations } from "../../utils/variables";
import { toastError } from "../../views/components/error";
import { toastSuccess } from "../../views/components/common/toast";

export function appointmentConfirmedListeners() {
    setupActionButtonListeners();

    setupOutsideClickHandler();

    if (eventRoom === null) {
        setupLocationBasedActions();
    } else {
        setupEventRoomActions();
    }
}

function setupActionButtonListeners() {
    const actionButtons = document.querySelectorAll('.appointment-confirmed__container .action .add-calendar button');
    actionButtons.forEach((element) => {
        element.addEventListener('click', toggleActionButtonHandler);
    });
}

function setupOutsideClickHandler() {
    const container = document.querySelector('.appointment-confirmed__container');
    if (container) {
        container.addEventListener('click', onClickOutsideDropdown);
    }
}

function setupLocationBasedActions() {
    const copyAddressBtn = document.getElementById('copy-address-confirmed');
    if (copyAddressBtn) {
        copyAddressBtn.addEventListener('click', onCopyAddressHandler);
    }
}

function setupEventRoomActions() {
    const eventRoomBtn = document.querySelector('.event-room button');
    if (eventRoomBtn) {
        eventRoomBtn.addEventListener('click', handleEventRoomBtn);
    }
}

function toggleActionButtonHandler(event) {
    event.stopPropagation();

    const isCurrentlyActive = this.classList.contains('action-button--clicked');

    blurAllActionButtons();
    closeAllDropdowns();

    if (!isCurrentlyActive) {
        this.classList.add('action-button--clicked');
        const dropdown = this.parentNode.querySelector('.action-dropdown');
        if (dropdown) {
            dropdown.classList.remove('action-dropdown--hidden');
        }
    }
}

function blurAllActionButtons() {
    const actionButtons = document.querySelectorAll('.appointment-confirmed__container .action .add-calendar button');
    actionButtons.forEach((element) => {
        element.classList.remove('action-button--clicked');
    });
}

function closeAllDropdowns() {
    const dropdowns = document.querySelectorAll('.appointment-confirmed__container .action .action-dropdown');
    dropdowns.forEach((element) => {
        element.classList.add('action-dropdown--hidden');
    });
}

function onClickOutsideDropdown() {
    blurAllActionButtons();
    closeAllDropdowns();
}

async function onCopyAddressHandler() {
    try {
        const addressEl = document.querySelector('.appointment-confirmed__container .location-address__text');
        const address = addressEl?.textContent?.trim();
        if (!address) {
            const locationObj = locations.find(location => location.id === locationId);
            if (!locationObj?.full_address) throw new Error('Error! Location is undefined.');
            await navigator.clipboard.writeText(locationObj.full_address);
        } else {
            await navigator.clipboard.writeText(address);
        }
        toastSuccess('Address copied to clipboard');
    } catch (error) {
        const errorMessage = error.message || 'Error! Cannot copy to clipboard.';
        toastError(errorMessage);
    }
}

async function handleEventRoomBtn() {
    try {
        const eventRoomURL = eventRoom?.room_url;
        if (!eventRoomURL || eventRoomURL.length === 0) {
            throw new Error("Event room URL is not available");
        }

        window.open(eventRoomURL, '_blank')?.focus();
    } catch (error) {
        const errorMessage = error.message || "Something wrong with url";
        toastError(errorMessage);
    }
}